// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Webflow: "saved, publish when ready" notice (WebflowPublishNotice.js).
   Shown after activate/deactivate until the customer publishes. */
.wf-publish-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  margin: 0 0 16px 0;
  background: #f5f1ff;
  border: 1px solid #d9ccff;
  border-radius: 10px;
  color: #2b2140;
  max-width: 640px;
}
.wf-publish-notice--done {
  background: #eefbf3;
  border-color: #bfe8cc;
}
.wf-publish-notice__icon {
  color: #5616ea;
  font-size: 20px;
  margin-top: 2px;
  flex: 0 0 auto;
}
.wf-publish-notice--done .wf-publish-notice__icon {
  color: #1f9d55;
}
.wf-publish-notice__body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.wf-publish-notice__body p {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
}
.wf-publish-notice__warn {
  color: #6b5f85;
  font-size: 13px;
}
.wf-publish-notice__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
}
.wf-publish-notice__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 0;
  border-radius: 8px;
  background: #5616ea;
  color: #fff;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.wf-publish-notice__btn:hover {
  background: #4a14d6;
}
.wf-publish-notice__btn:disabled {
  opacity: 0.6;
  cursor: default;
}
.wf-publish-notice__alt {
  font-size: 13px;
  color: #6b5f85;
}
.wf-publish-notice__error {
  color: #b42318;
  font-size: 13px;
}

/* inline variant: one line under the site row of the Webflow channel */
.wf-publish-inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  font-size: 14px;
  color: #4b4360;
}
.wf-publish-inline__btn {
  padding: 5px 12px;
  font-size: 13px;
}
.wf-publish-inline__note {
  font-size: 12px;
  color: #8a819c;
}
.wf-publish-inline__done {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #1f9d55;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/WebflowPublishNotice.css"],"names":[],"mappings":"AAAA;kEACkE;AAClE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Webflow: \"saved, publish when ready\" notice (WebflowPublishNotice.js).\r\n   Shown after activate/deactivate until the customer publishes. */\r\n.wf-publish-notice {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  padding: 14px 16px;\r\n  margin: 0 0 16px 0;\r\n  background: #f5f1ff;\r\n  border: 1px solid #d9ccff;\r\n  border-radius: 10px;\r\n  color: #2b2140;\r\n  max-width: 640px;\r\n}\r\n.wf-publish-notice--done {\r\n  background: #eefbf3;\r\n  border-color: #bfe8cc;\r\n}\r\n.wf-publish-notice__icon {\r\n  color: #5616ea;\r\n  font-size: 20px;\r\n  margin-top: 2px;\r\n  flex: 0 0 auto;\r\n}\r\n.wf-publish-notice--done .wf-publish-notice__icon {\r\n  color: #1f9d55;\r\n}\r\n.wf-publish-notice__body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  min-width: 0;\r\n}\r\n.wf-publish-notice__body p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  line-height: 1.45;\r\n}\r\n.wf-publish-notice__warn {\r\n  color: #6b5f85;\r\n  font-size: 13px;\r\n}\r\n.wf-publish-notice__actions {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n  margin-top: 4px;\r\n}\r\n.wf-publish-notice__btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 14px;\r\n  border: 0;\r\n  border-radius: 8px;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  font: inherit;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n.wf-publish-notice__btn:hover {\r\n  background: #4a14d6;\r\n}\r\n.wf-publish-notice__btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n.wf-publish-notice__alt {\r\n  font-size: 13px;\r\n  color: #6b5f85;\r\n}\r\n.wf-publish-notice__error {\r\n  color: #b42318;\r\n  font-size: 13px;\r\n}\r\n\n/* inline variant: one line under the site row of the Webflow channel */\n.wf-publish-inline {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  font-size: 14px;\n  color: #4b4360;\n}\n.wf-publish-inline__btn {\n  padding: 5px 12px;\n  font-size: 13px;\n}\n.wf-publish-inline__note {\n  font-size: 12px;\n  color: #8a819c;\n}\n.wf-publish-inline__done {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #1f9d55;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
